/**
 * axios 全局配置
 * TODO: 拦截器全局配置
 */

import axios from 'axios'
import store from '../store'
import router from '../router'
import {
  Message
} from 'element-ui'
import Auth from '@/utils/auth'

let getTokenLock = false
let CancelToken = axios.CancelToken // 用来取消一次请求
let requestList = [] // 每次请求的列表

/**
 * token 校验
 * @param {function} cancel  中断函数
 * @param {function} callback 回调函数
 * @description 校验token是否过期，过期后，通过跳转至登录页面，重新登录
 */
function checkToken (cancel, callback) {
  if (!Auth.hasToken()) {
    let method = Auth.tokenTimeoutMethod
    if (method === 'getNewToken') {
      if (getTokenLock) {
        setTimeout(function () {
          checkToken(cancel, callback)
        }, 500)
      } else {
        getTokenLock = true
        store.dispatch('auth/getNewToken').then(() => {
          console.log('获取到新的token')
          callback()
          getTokenLock = false
        })
      }
    } else if (method === 'jumpAuthPage' && Auth.isLogin()) {
      if (router.currentRoute.path !== '/login') {
        cancel()
        router.push('/login')
      }
    }
  } else {
    callback()
  }
}

/**
 * 阻止短时间内的重复请求
 * @param {string} url 当前请求的url地址
 * @param {function} c 中断请求的函数
 */
function stopRepeatRequest (url, c) {
  for (let i = 0; i < requestList.length; i++) {
    if (requestList[i] === url) {
      c()
      return
    }
  }
  requestList.push(url)
}

// 请求超时设置
const service = axios.create({
  timeout: 5000
})

// http request 拦截器
service.interceptors.request.use(
  config => {
    let cancel
    config.cancelToken = new CancelToken(function executor (c) {
      cancel = c
    })
    checkToken(cancel, function () {
      Auth.setLoginStatus()
      config.headers.Authorization = `${store.state.user.token}`
    })
    stopRepeatRequest(config.url, cancel)
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
service.interceptors.response.use(
  response => {
    for (let i = 0; i < requestList.length; i++) {
      setTimeout(function () {
        requestList.splice(i, 1)
      }, 500)
      break
    }
    return Promise.resolve(response.data)
  },
  error => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    } else if (error.response) {
      switch (error.response.status) {
        case 401:
          router.push('error/401')
          break
        case 403:
          router.push('error/403')
          break
        default:
          Message({
            message: `服务器错误！错误代码：${error.response.status}`,
            type: 'error'
          })
      }
      return Promise.reject(error.response.data)
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/ajax.js